import { Toaster as Sonner } from 'sonner';
import { useAppSelector } from '@/store/hooks';

export function Toaster() {
  const theme = useAppSelector((state) => state.theme.mode);

  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        style: {
          background: 'var(--color-surface)',
          color: 'var(--color-foreground)',
          border: '1px solid var(--color-border)',
        },
      }}
    />
  );
}
